import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { TransitionGroup } from "react-transition-group";
import PrimaryButton from "shared/components/PrimaryButton";
import { COLOR_GREY_6 } from "shared/theme/colors";
import { border, flex } from "shared/theme/mixins";

export const StyledContainer = styled(Box)`
  ${flex({ fd: "column" })};
  ${border(1, COLOR_GREY_6)};
  gap: 0.5rem;
  border-radius: 0.75rem;
  padding: 1rem;
`;

export const StyledTransitionGroup = styled(TransitionGroup)`
  & > *:not(:last-child) {
    margin-bottom: 1.5rem;
  }
`;

export const StyledDeleteButton = styled(Box)`
  ${flex({ ai: "flex-start" })};
  column-gap: 4px;
  cursor: pointer;
`;

export const StyledButton = styled(PrimaryButton)`
  width: 100%;
  margin-top: 1rem;
`;
